import baseLogger, { CONTEXTS } from 'widget/logger';
import createTaggedUrl from 'api/createTaggedUrl';
import HttpError from 'widget/Errors/HttpError';
import Logger from 'modules/Logger/Logger';
import { Playlist } from 'state/Playlist/types';
import { TransportInterface } from 'widget/utils/transport/types';

/*
 * Fetch playlist radio data given a playlist id
 */
export async function fetchPlaylist({
  ampUrl = '',
  logger = baseLogger,
  playlistId,
  ownerId,
  transport,
}: {
  ampUrl?: string;
  logger?: Logger;
  playlistId: string;
  ownerId: string;
  transport: TransportInterface;
}): Promise<Playlist> {
  if (!playlistId) {
    const errObj = new HttpError(
      400,
      'Failed to fetch playlist radio info, playlist radio id missing.',
    );
    logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
    throw errObj;
  }

  const [url, requestName] = createTaggedUrl`${{
    ampUrl,
  }}/api/v3/collection/user/${{
    owner: String(ownerId),
  }}/collection/${{ id: String(playlistId) }}`;

  const response = await transport.get(url, { params: { requestName } });
  const { data } = response as { data?: Playlist };

  if (!data || data?.tracks?.length < 1) {
    const errObj = new HttpError(
      400,
      'Failed to fetch playlist radio info, no results.',
    );
    logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
    throw errObj;
  }

  return data;
}
